
import InStoreLocation from './InStoreLocation.vue';
import ListAndRegistry from './ListAndRegistry.vue';
import SpecialProductMessageBox from './SpecialProductMessageBox.vue';
import Vue from 'vue';
import { Component } from 'vue-property-decorator';
import { ILocalStoreJson } from 'JS/types/LocalStore';
import { IProductDetailPageJson, IProductDetailProductJson } from 'JS/types/PDP';

@Component({
	name: 'AuxItems',
	components: {
		SpecialProductMessageBox,
		ListAndRegistry,
		InStoreLocation
	},
})
class AuxItems extends Vue {
	get product(): IProductDetailProductJson {
		return this.$store.state.product;
	}

	get details(): IProductDetailPageJson {
		return this.$store.state.details;
	}

	get localStore(): ILocalStoreJson {
		return this.$store.state.localStore;
	}

	get showSpecialMessageBox(): boolean {
		return this.$store.getters.showSpecialMessageBox;
	}

	get isComingSoon(): boolean {
		return this.$store.getters.isComing;
	}

	get showListAddButton(): boolean {
		return this.isComingSoon || !this.showSpecialMessageBox;
	}

	get showInStoreLocation(): boolean {
		return !this.showSpecialMessageBox && this.localStore && !this.localStore.comingSoon;
	}

	get showCallAutoService(): boolean {
		return this.details.isAutoService;
	}
}

export default AuxItems;
